<script setup>
import {computed, ref, watch, watchEffect} from 'vue';
import {
    searchType,
    checkboxs,
    checkList,
    tableData,
    init,
    search,
    total,
    formData, pagination,headerInfo
} from './index';
import request from "@/service/request";
import {
    exportCityHigh, exportCityHighTime,
} from "@/service/api";
import {cityFilterMethod, exportFile} from "@/tool/public";
import {CircleCheck, Delete, Download} from "@element-plus/icons-vue";
import SelectRow from '@/view/dataExport/components/selectRow.vue';
import {permissionOfDownload} from "@/view/dataExport/standardCity";
import {uncheckedList} from "@/view/dataExport/standardProject";
const props = defineProps(['visible'])

const removeChildren = (arr, level) => {
  for(let i = 0; i < arr.length; i++){
    if(arr[i].children){
      if(level === 1){
        delete arr[i].children;
      }else{
        removeChildren(arr[i].children, level+1)
      }
    }
  }
}

const onchange = (v) => {
  console.log('333333333333333333');
  console.log(v);
  console.log(v[1]);
  console.log(v.length);
  var arr = []
  var arr2 = []
  var provCode = ''
  var cityCode = ''
  var areaCode = ''
  for (var i in v) {
    console.log(v[i].length);
    var num = v[i].length
    if (num == 1) {
      arr.push(v[i][0])
      provCode += ',' + v[i][0]
    }
    if (num > 1) {
      if (!arr.includes(v[i][0])) {
        if (num > 2) {
          if (!arr2.includes(v[i][1])) {
            areaCode += ',' + v[i][2]
          }
        } else {
          cityCode += ',' + v[i][1]
          arr2.push(v[i][1])
        }
      }
    }
  }
  console.log('=----------------=-=-==-==-=-=-=-');
  console.log('provCode   ' + provCode.substring(1));
  formData.value.provCode = provCode.substring(1)
  console.log('cityCode   ' + cityCode.substring(1));
  formData.value.cityCode = cityCode.substring(1)
  console.log('areaCode   ' + areaCode.substring(1));
  formData.value.areaCode = areaCode.substring(1)
  console.log('................................');
  
  console.log(arr);
  
  

  console.log(formData);
  
  console.log('66666666666666666');
}

const  formItems = computed(()=>{
    removeChildren(headerInfo.value.provinces, 0);
    return [
        {
            prop: "quarter", label: "季度", type: 'select', options: headerInfo.value.quarter, placeholder: "请选择"
        },
        {
            prop: "address",
            label: "省/市",
            type: 'cascader',
            props: {checkStrictly: true,value:'code',label:'name', multiple: true},
            placeholder: "请选择",
            options: headerInfo.value.provinces
        },
    ]
})
const cityCascaderProps = {
    checkStrictly: true,
}
const handleCurrentChange  = (val) => {
    pagination.value.pageNum = val
    console.log(pagination.value)
}

const exportInfo = async () => {
    const {address} = formData.value
    let params = {
          ...formData.value,
        ...pagination.value,
        provCode: formData.value.provCode,
        cityCode: formData.value.cityCode,
        areaCode: formData.value.areaCode,
        selectedColumns: [...checkList.value],
    }
    delete params.address
    let data = await request({
        url: exportCityHigh,
        method: 'post',
        data: {
            selectedColumns: [...checkList.value],
            ...params,
        },
        download:true,
        responseType: 'blob',
    })
    let str = '高标仓城市层级数据.xlsx'
    exportFile(data,str)
    await exportTime()
}
const exportTime = async () => {
    const {address} = formData.value
    let params = {
        ...formData.value,
        provCode: address[0] ? address[0] : '',
        cityCode: address[1] ? address[1] : '',
        areaCode: address[2] ? address[2] : '',
    }

    delete params.address
    await request({
        url: exportCityHighTime,
        method: 'post',
        data: {
            selectedColumns: [...checkList.value],
            ...params,
        },
    })

}

const arr2Object = (c, n) => {
  let key = n['name'];
  c[key] = n;
  return c;
}

const tableHead = computed(() => {
  return checkboxs.value.filter(e => !e['checked'])
})

// 处理字段的选中或取消
const columnsDict = computed(() => {
  return checkboxs.value.reduce(arr2Object, {})
})

const changeBasicInfo = (v) => {
  if(v['checked']){
    uncheckedList.value.push(v);
    checkList.value = checkList.value.filter(e => e !== v['name']);
  }else{
    checkList.value.push(v['name']);
    uncheckedList.value = uncheckedList.value.filter(e => e['name'] !== v['name']);
  }
}
// 项目位置
const projectLocationRef = ref(['province', 'city', 'area']);
const projectLocation = computed(() => {
  return checkboxs.value.length > 0 ? projectLocationRef.value.map(key => columnsDict.value[key]) : [];
})
// 项目参数
const projectParamsRef = ref(['areaTotal', 'vacancyRate', 'estimatedEffective',
  'preadd', 'nettakeup', 'currentseasonadd']);
const projectParams = computed(() => {
  return checkboxs.value.length > 0 ?  projectParamsRef.value.map(key => columnsDict.value[key]) : [];
})
const resetSelected = () => {
  checkList.value =checkboxs.value.map(({name}) => name)
  checkboxs.value.forEach(e => e['checked'] = false);
  checkList.value = [];
}
const requireFields = ref({
  'projectName': '项目名称',
  'province': '省',
  'area': '区县',
  'gpsLat': 'GPS纬度',
  'areaTotal': '现有存量(m²)',
  'effectiveRent': '有效租金(元/m²·月)',
  'buildingArea': '在建面积(m²)',
  'newSupply': '本季度增量(㎡)',
  'netTakeup': '本季度净吸纳量(m²)',
  'buildingNumber': '栋数',
  'rptStorageTypeNames': '存储类型',
  'bearing': '承重(t/㎡）',
  'fireFacilities': '消防设施',
  'floorTypeNames': '地坪材质',
  'parkFacilities': '配套设施-园区信息',
  'landUse': '土地用途',
  'landProperty': '土地性质'
})
watch(props, () => {
  if(props.visible) init()
}, {immediate: true});
const clearHandleSelect = (v) => {
  v['checked'] = false;
  uncheckedList.value = uncheckedList.value.filter(e => e['name'] !== v['name']);
  checkList.value = checkboxs.value.map(({name}) => name)
}
</script>
<template  >
    <div v-if="visible" class="data-container">
        <div class="ed-project-search">
            <div class="ed-project-form">
                <div class="app-search-form" style="align-items: center">
                    <p style="width: 100px;">数据时间</p>
                    <div v-for="(item,index) in formItems"
                         :class="{'app-sf-no-mr': formItems && index === formItems.length - 1}"
                         class="app-search-fitem">
                        <span>{{ item.label }}：</span>
                        <div class="app-search-ops">
                            <template v-if="item.type === 'input'">
                                <el-input v-model="formData[item.prop]" :placeholder="item.placeholder" size="small"></el-input>
                            </template>
                            <template v-else-if="item.type === 'select'">
                                <el-select v-model="formData[item.prop]" :placeholder="item.placeholder" clearable collapse-tags multiple
                                           size="small">
                                    <el-option v-for="v in item.options" :key="v" :label="v"
                                               :value="v">{{v}}</el-option>
                                </el-select>
                            </template>

                            <template v-else-if="item.type === 'cascader'">
                                <el-cascader
                                    filterable
                                    :filter-method="cityFilterMethod"
                                    :options="item.options"
                                    :placeholder="item.placeholder"
                                    :props="item.props"
                                    @Change="onchange"
                                    collapse-tags='true'
                                    clearable
                                    size="small"
                                />
                            </template>

                        </div>
                    </div>
                </div>
              <select-row
                  name="项目位置"
                  :values="projectLocation"
                  @onChange="changeBasicInfo"
                  :requires="requireFields"
              />
              <select-row
                  name="项目参数"
                  :values="projectParams"
                  @onChange="changeBasicInfo"
                  :requires="requireFields"
              />
            </div>
        </div>

      <div class="app-search-btns" >
        <el-button size="small" :icon="Delete" @click="resetSelected">清空选择</el-button>
        <el-button size="small" :icon="CircleCheck" type="primary" @click="search">确认选择</el-button>
      </div>
      <dl class="dl-row">
        <dt>未选中字段</dt>
        <dd class="dd-remove"
            v-for="v in checkList"
            :key="v['name']"
            @click="clearHandleSelect(v)"
        >
          <span class="dd-close">x</span>
          {{v['text']}}
        </dd>
      </dl>
        <div class="export-container">
            <div class="ed-project-table-box-36">
                <div class="table-container rs-el-table">
                    <el-table
                        style="font-size: 12px;height: 100%;"
                        :key="searchType"
                        :data="tableData"
                        show-overflow-tooltip
                    >
                        <el-table-column
                            width="200"
                            v-for="item in tableHead"
                            :key="item.name"
                            :label="item.text"
                            :prop="item.name"
                            align="center"/>
                    </el-table>
                </div>
                <div class="ed-project-pagination">
                    <el-pagination
                        :total="total"
                        background
                        :page-size="pagination.pageSize"
                        layout="prev, pager, next, jumper"
                        small
                        @current-change="handleCurrentChange"
                    />
                    <a
                        v-if="permissionOfDownload"
                        class="download-link"
                        href="javascript:;"
                        @click="exportInfo"
                    ><el-icon style="margin-right: 4px;"><Download /></el-icon>导出数据</a>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="less" scoped>
@import "../../../assets/css/public.less";
@import "../index.less";
.export-container{
  flex-basis: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.data-container{
  display: flex;
  flex-direction: column;
  flex: auto;
  min-height: 0;
}
.ed-project-table-box-36{
  flex-basis: 100%;
  min-height: 0;

  display: flex;
  flex-direction: column;
}

.table-container{
  background-color: red;
  flex-basis: 100%;
  min-height: 0;
}

.dl-row{
  font-size: 12px;
  color: #0A9BFC;
  display: flex;
  padding: 4px 0;
  & dd{
    padding: 0 6px;
    color: #999;
    cursor: pointer;
  }
}
.download-link{
  font-size: 12px;
  line-height: 40px;
  text-decoration: none;
  padding: 0 20px;
}

.dd-close{
  float: right;
  display: none;
}

.dd-remove{
  &:hover{
    .dd-close{
      display: block;
    }
  }
}
</style>